import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokonkankadarshancabs() {



  const cardData =
  {
    keyword: 'Pune to Konkan Darshan Cabs',
    heading: 'Sanavi Travels: Pune to Konkan Darshan Cabs',
    headingDescription: 'Sanavi Travels offers reliable Pune to Konkan Darshan Cabs, providing safe, comfortable, and hassle-free transportation for families, friends, corporate groups, and pilgrimage travelers planning a scenic and cultural journey from Pune to the Konkan region. Our fleet of sedans, SUVs, and luxury cabs is well-maintained with spacious seating, air-conditioning, and ample luggage space to ensure a smooth and enjoyable long-distance journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Konkan destinations such as Ganpatipule, Ratnagiri, Tarkarli, Malvan, Devgad, Murud, Harihareshwar, Dapoli, and Alibaug. Choose Sanavi Travels for trusted Pune to Konkan Darshan cab services, delivering comfort, safety, and a memorable coastal travel experience.',

    top: 'Top Places to Visit in Konkan with Sanavi Travels',


"topPlaces": [
  {
    "title": "Ganpatipule Beach",
    "description": "Ganpatipule Beach is a pristine coastal stretch along the Konkan coast, known for its golden sands, clear waters, and serene ambiance. The nearby Ganpatipule Temple dedicated to Lord Ganesha adds spiritual significance. The beach is ideal for swimming, sunbathing, and enjoying tranquil sunsets."
  },
  {
    "title": "Ratnagiri Fort",
    "description": "Ratnagiri Fort, also known as Ratnadurg, is a historic sea fort overlooking the Arabian Sea. It features massive walls, watchtowers, and scenic views of the coastline. The fort attracts history enthusiasts and photographers seeking a glimpse of Konkan’s maritime heritage."
  },
  {
    "title": "Tarkarli Beach",
    "description": "Tarkarli Beach is famous for its white sands, crystal-clear waters, and vibrant marine life. Visitors can enjoy water sports such as snorkeling, scuba diving, and jet skiing. The beach is a paradise for adventure seekers and nature lovers."
  },
  {
    "title": "Kunkeshwar Temple",
    "description": "Kunkeshwar Temple is an ancient Shiva temple located near Devbagh, built along the Konkan coastline. It is revered for its architectural beauty and spiritual significance. The temple’s location by the sea makes it a peaceful pilgrimage site."
  },
  {
    "title": "Bhatye Beach",
    "description": "Bhatye Beach in Ratnagiri is a calm and less crowded beach, surrounded by palm trees and scenic views. It is perfect for peaceful walks, picnics, and experiencing the tranquil side of Konkan’s coastline."
  },
  {
    "title": "Jaigad Fort",
    "description": "Jaigad Fort is a coastal fort perched on cliffs overlooking the Arabian Sea. It features historic walls, watchtowers, and a lighthouse. The fort provides panoramic views of the sea and nearby beaches, making it a must-visit for history buffs and photographers."
  },
  {
    "title": "Vijaydurg Fort",
    "description": "Vijaydurg Fort, known as the 'Eastern Gibraltar of India,' is an ancient sea fort with rich Maratha history. Surrounded by water on three sides, it offers stunning views, hiking trails, and glimpses of historic architecture. The fort is popular among history enthusiasts and trekkers."
  },
  {
    "title": "Devbagh Beach",
    "description": "Devbagh Beach is a serene and scenic beach near Tarkarli, ideal for swimming, sunbathing, and enjoying water sports. The tranquil environment and clear waters make it a perfect spot for family outings and adventure activities."
  },
  {
    "title": "Anjarle Beach & Ganesh Temple",
    "description": "Anjarle Beach is a peaceful coastal destination with a beautiful stretch of sand and the historic Kadyawarcha Ganpati Temple. The temple attracts devotees, while the beach offers a quiet retreat for relaxation and nature walks."
  },
  {
    "title": "Sawantwadi Palace",
    "description": "Sawantwadi Palace, located in the Konkan region, is a historic royal palace known for its architectural grandeur and intricate wooden carvings. The palace houses a museum with artifacts, paintings, and cultural exhibits, offering insights into Konkan’s royal heritage."
  }
]
,




"services": [
  {
    "name": "Pune to Konkan Darshan Cabs",
    "description": "Pune to Konkan Darshan Cabs provide comfortable and reliable cab services for travelers planning a scenic trip from Pune to Konkan. Ideal for families, friends, and group tours, these cabs ensure smooth travel with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Konkan Darshan Cab Package Pune",
    "description": "Konkan Darshan Cab Package Pune offers customized cab packages for Konkan tours. With flexible pick-up options, comfortable seating, and experienced chauffeurs, it is perfect for sightseeing, weekend trips, and group travel."
  },
  {
    "name": "AC Cab Konkan Tour",
    "description": "AC Cab Konkan Tour provides air-conditioned cabs for a cool and relaxing journey along the Konkan coast. Spacious interiors and professional drivers ensure a comfortable and hassle-free trip."
  },
  {
    "name": "Luxury Cab Konkan Darshan",
    "description": "Luxury Cab Konkan Darshan offers premium cab services for travelers seeking a stylish and comfortable journey. Equipped with modern amenities, these cabs are ideal for VIP trips and family tours."
  },
  {
    "name": "Family Cab Konkan Tour",
    "description": "Family Cab Konkan Tour caters to families traveling from Pune to Konkan. Spacious seating, child-friendly interiors, and safe driving ensure a smooth and enjoyable trip for all family members."
  },
  {
    "name": "Group Travel Konkan Cabs",
    "description": "Group Travel Konkan Cabs provide vehicles for large groups traveling together. Well-maintained cabs with experienced chauffeurs make it convenient for corporate trips, school outings, or friends' getaways."
  },
  {
    "name": "Affordable Konkan Cab Package",
    "description": "Affordable Konkan Cab Package offers budget-friendly travel options without compromising on comfort or safety. Ideal for solo travelers, families, or small groups planning a Konkan trip."
  },
  {
    "name": "Chauffeur Driven Konkan Cab",
    "description": "Chauffeur Driven Konkan Cab ensures a stress-free travel experience with professional drivers handling routes and traffic. Passengers can relax and enjoy the scenic drive along the Konkan coast."
  },
  {
    "name": "Best Konkan Darshan Cab Pune",
    "description": "Best Konkan Darshan Cab Pune provides top-quality cabs and excellent service for a superior travel experience. Timely pick-ups, well-maintained vehicles, and skilled drivers ensure safe and reliable transport."
  },
  {
    "name": "Pune Konkan Taxi Service",
    "description": "Pune Konkan Taxi Service offers dependable taxi services for individuals and groups traveling from Pune to Konkan. Comfortable and well-maintained vehicles with experienced drivers guarantee a smooth journey."
  },
  {
    "name": "Tourist Cab Konkan",
    "description": "Tourist Cab Konkan is designed for sightseeing and leisure travel along the Konkan coast. Spacious, safe, and comfortable, these cabs ensure a pleasant experience for tourists."
  },
  {
    "name": "Long Distance Cab Pune",
    "description": "Long Distance Cab Pune provides reliable cab services for extended trips to Konkan. Well-equipped vehicles and professional chauffeurs make it ideal for weekend getaways and long-distance tours."
  },
  {
    "name": "Coastal Tour Cab Pune",
    "description": "Coastal Tour Cab Pune offers cab services for exploring the beautiful Konkan coastline. Comfortable seating and experienced drivers ensure a safe, enjoyable, and scenic travel experience."
  },
  {
    "name": "Konkan Travel Cab",
    "description": "Konkan Travel Cab provides convenient and dependable cab services for travelers exploring Konkan from Pune. Flexible schedules, spacious interiors, and professional drivers make every journey comfortable and hassle-free."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows travelers to reserve cabs for Konkan tours easily. With transparent pricing, flexible timing, and reliable service, booking your Pune to Konkan cab trip has never been simpler."
  }
],
"tableData": [
  ["Pune to Konkan Darshan Cabs", "Konkan Darshan Cab Package Pune"],
  ["AC Cab Konkan Tour", "Luxury Cab Konkan Darshan"],
  ["Family Cab Konkan Tour", "Group Travel Konkan Cabs"],
  ["Affordable Konkan Cab Package", "Chauffeur Driven Konkan Cab"],
  ["Best Konkan Darshan Cab Pune", "Pune Konkan Taxi Service"],
  ["Tourist Cab Konkan", "Long Distance Cab Pune"],
  ["Coastal Tour Cab Pune", "Konkan Travel Cab"],
  ["Online Cab Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Bhimashankar Cab Package with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and comfortable Pune to Bhimashankar cab packages, ideal for devotees, group trips, and day excursions to the sacred Bhimashankar Jyotirlinga."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Cabs",
    "WhyChoosedescription": "Travel in air-conditioned, spacious, and regularly serviced cabs for a smooth and enjoyable journey from Pune to Bhimashankar."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Hill Routes",
    "WhyChoosedescription": "Our professional drivers are experienced in Pune to Bhimashankar routes, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Pune to Bhimashankar cab packages, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel inquiries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized cab packages based on your travel preferences and schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Bhimashankar cab packages."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab packages from Pune to Bhimashankar?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable cab packages for travel from Pune to Bhimashankar.'
  },
  {
    question: 'How can I book a Pune to Bhimashankar cab package?',
    answer: 'You can book through our website or by contacting our 24x7 customer support team for assistance.'
  },
  {
    question: 'What types of cabs are available for Pune to Bhimashankar trips?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars suitable for a comfortable journey.'
  },
  {
    question: 'Are drivers experienced for Pune to Bhimashankar routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the route to ensure safe travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup in Pune and drop-off at Bhimashankar.'
  },
  {
    question: 'Is the cab service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services for your convenience.'
  },
  {
    question: 'Are safety and hygiene protocols followed?',
    answer: 'All cabs are sanitized regularly, and drivers follow strict safety and hygiene guidelines.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate account payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your travel from Pune to Bhimashankar.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Pradeep Shinde',
    feedback: 'The Pune to Bhimashankar cab package with Sanavi Travels was excellent. Comfortable ride and professional driver made our pilgrimage hassle-free.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sunita Patil',
    feedback: 'Highly satisfied! The cab was clean, air-conditioned, and the driver was very courteous. Perfect day trip to Bhimashankar.',
    rating: 5
  }
];














































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Konkan Darshan Cabs - Sanavi Travels",
  "description": "Book Pune to Konkan Darshan cabs with Sanavi Travels. AC and luxury cabs for family trips, group travel, long-distance coastal tours, sightseeing, and comfortable chauffeur-driven journeys across Konkan.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Pune to Konkan Darshan Cabs | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs from Pune to Konkan with Sanavi Travels. Ideal for family trips, group tours, long-distance coastal sightseeing, and safe chauffeur-driven travel across the Konkan region."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/51.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokonkankadarshancabs;